<template>
  <div class="UIFormActions">
    <div
      class="UIFormActions__content"
      :style="{
        '--form-width': formDimensions?.width
          ? `${formDimensions.width}px`
          : 'auto',
        '--form-right-spacing': formDimensions?.rightSpacing
          ? `${formDimensions.rightSpacing}px`
          : '0px',
      }"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { inject } from 'vue'

interface FormDimensions {
  width: number
  rightSpacing: number
}

const formDimensions = inject<FormDimensions>('formDimensions')
</script>

<style scoped lang="scss">
.UIFormActions {
  position: fixed;
  padding: 1.5rem 0;
  background: $color-white;
  border-top: solid 1px $color-neutral-10;
  bottom: 0;
  right: 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;

  .UIFormActions__content {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    width: 100%;
    margin-right: var(--form-right-spacing, 0px);
    width: var(--form-width, 100%);
  }
}
</style>
